import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Button, Col, Row } from 'react-bootstrap';
import Slider from "react-slick";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AnchorLink from 'react-anchor-link-smooth-scroll';

function BonnieAndSaks() {
    window.scrollTo(0, 0);
    const [focus, setFocus] = React.useState(false);
    return (
        <div>
            <Helmet>

                <title>525% Growth in Architect & Interior Designer Leads: The Bonnie & Saks Story</title>
                <meta name="description" content="" />
                <link rel="canonical" href="https://anbluxury.com/case-studies/adani-realty-case-study.html" />

            </Helmet>
            {/* first fold */}
            <div className="casestudy">
                <div className="box padmmdt padmmdb">

                    <Container>

                        <p className="text-left p1 pdl10"> <span class="spcase">BONNIE &</span> SAKS</p>
                    </Container>

                    <Container fluid className="padbsmt padbsmb">
                        <Row>
                            <Col lg="2"></Col>
                            <Col lg="8">
                                <div className="circleboxfirst circleboxfirst-relative  padssmb">
                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="roundbx" width="30%" alt="" />

                                    <div className="boxcentered tpfold">
                                        <h4 className="d-none d-sm-block cuspn"> <span class=""> 525% Growth in Architect & Interior Designer Leads:  </span><br />  The Bonnie & Saks Story  <br /></h4>
                                        <h4 className="d-block d-sm-none"> <span class="cuspn"> 525% Growth in Architect & Interior Designer Leads: </span>  <br />  The Bonnie & Saks Story  <br /></h4>

                                    </div>
                                </div>
                            </Col>
                            <Col lg="2"></Col>
                        </Row>
                    </Container>
                </div>
            </div>
            {/* The brand fold */}
            <div className="lgbox  problem">

                <Container fluid className="tpfold pdr0 mbpdr15">
                    <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>BRAND</strong>  </p>
                            <p className="marbmdt mbt20 ">
                                Bonnie & Saks is a luxury bedding brand with a strong focus on quality materials, craftsmanship, and a refined aesthetic, the brand aims to elevate the sleep experience for discerning consumers and design professionals.
                            </p>
                            <p className="">
                                As a young challenger in the luxury bedding category, Bonnie & Saks stands out through:
                            </p>

                            <p className="">
                                1. Luxury-grade product quality
                            </p>
                            <p className="">
                                2. A design-first approach catered to modern Indian homes
                            </p>
                            <br></br>
                            <br></br>
                        </Col>

                        <Col lg={{ span: 5 }} md={{ span: 4 }} sm={{ span: 12 }} xs={{ span: 12 }} className="offset-lg-1 mbpdr15">
                            <br></br>
                            <br></br>
                            <br></br>
                           
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/bonnie/bonnie-brand.png`} width="100%" height="100%" className="img-fluid text-right" />
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* The opportunity */}


            <div id="letsdo" className="seoapproach bgbl padmmdt padmmdb ">
                <Container>

                    <Row>
                        <Col sm={12}>
                            <p className="text-center p1 mrg30 " > <span class="spcase">THE</span> <strong>CHALLENGE</strong>  </p>
                        </Col>
                         <Col md={2} lg={2}></Col>
                        <Col md={8} lg={8}>
                            <br></br>
                            <br></br>
                            <p style={{ textAlign: 'center' }}>Despite a strong product line and positive customer feedback, Bonnie & Saks struggled with key growth bottlenecks:</p>
                            <br></br>
                            <br></br>
                        </Col>
                         <Col md={2} lg={2}></Col>

                    </Row>

                    <div className="appbox padssmb d-none d-sm-block">
                        <img src={`${process.env.PUBLIC_URL}/img/approach2.png`} className="imgwidt img-fluid" alt="" />
                        <div className="top-left">
                            <h4><strong> Brand </strong><br /> <i>Awareness </i></h4>
                            <p>Limited brand awareness in the luxury bedding category</p>
                        </div>

                        <div className="top-right">
                            <h4><strong>Consumer  </strong><br /> <i>Traffic</i></h4>
                            <p>Inconsistent consumer traffic and low repeat purchase behaviour.</p>
                        </div>

                        <div className="bottom-left">
                            <h4> <strong>Luxury</strong><br /> <i>Positioning</i></h4>
                            <p>There was no clear luxury positioning or narrative that differentiated the brand.</p>
                        </div>


                        <div className="bottom-right">
                            <h4><strong>Marquee </strong><br /> <i>Events</i></h4>
                            <p>Underutilization of marquee events like India Design ID for lead generation</p>
                        </div>
                        <div className="centered"><h1>The <span>Challenge</span></h1></div>
                    </div>

                     <div className="appbox  padssmb d-block d-sm-none">
                        <h1>The <span>Challenge</span></h1> <br />

                        <h4><strong> Brand </strong><br /> <i>Awareness </i></h4>
                        <p>Limited brand awareness in the luxury bedding category</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Consumer  </strong><br /> <i>Traffic</i></h4>
                        <p>Inconsistent consumer traffic and low repeat purchase behaviour.</p>

                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Luxury</strong><br /> <i>Positioning</i></h4>
                        <p>There was no clear luxury positioning or narrative that differentiated the brand.</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Marquee </strong><br /> <i>Events</i></h4>
                        <p>Underutilization of marquee events like India Design ID for lead generation</p>
                    </div>


                    <Row>
                        <Col md={2} lg={2}></Col>
                        <Col md={8} lg={8}>
                            <br></br>
                            <br></br>
                            <p style={{ textAlign: 'center' }}>The brand approached A&B to help build a high-conversion pipeline of qualified luxury leads, both B2C and B2B, and to establish itself as a digitally powerful global luxury brand.</p>
                        </Col>
                        <Col md={2} lg={2}></Col>
                    </Row>

                </Container>
                {/* <img src={`${process.env.PUBLIC_URL}/img/approach.png`} className="img-fluid" /> */}
            </div>


            <div className="bgbl casestudy">
                <Container>
                    <Row>
                    <Col sm={12}>
                        <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong style={{color:'#fff'}}>PROCESS</strong>  </p>
                    </Col>
                </Row>
                <Process />
                </Container>
               
            </div>

            <div className="lgbox  problem padbxsb">
                <Container fluid className="tpfold ">
                    <Row>
                        <Col lg="10" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>IMPACT</strong> </p>
                        </Col>
                        <Row>
                            <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                                <div id="iwantto" className="seomatters casestudyimpacts bgb">
                                    <Container className="padbmdt padbmdb">
                                        <p>Our partnership delivered measurable and sustained growth for Bonnie & Saks:</p>
                                        <br></br>
                                        <br></br>
                                        <Row className="padsmdb">
                                             <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Lead from <br></br> Oside <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>500%  increase in qualified leads from OSIDE.</p><br />
                                            </Col>

                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Lead <br></br> Growth <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>525% increase in monthly leads from architects and interior designers</p><br />
                                            </Col>
                                           
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Lead <br></br> Quality <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>A 250% increase in sales-qualified leads, with higher lead quality and strong intent, resulting in purchase-ready customers.</p><br />
                                            </Col>
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Sales <br></br> Conversion <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>Improved sales conversions through a more effective follow-up system.</p><br />
                                            </Col>
                                         
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className=""> Brand <br></br> Perception  <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>Enhanced brand perception, positioning Bonnie & Saks as a luxury yet value-driven bedding brand.</p><br />
                                            </Col>
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Events <br></br> ROI <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>125+ Architects & Interior Designers RSVPs captured for ID event via targeted digital campaigns.</p><br />
                                            </Col> 
                                        </Row>

                                         <AnchorLink href="" className="btn btn-seo" >Let's Get More Sales </AnchorLink>

                                    </Container>
                                </div>
                            </Col>
                        </Row>
                    </Row>

                </Container>

                
            </div>

            <div className="lgbox build endbox">
                <Container fluid className="pdlr0">
                    <Row className="text-left  mglr0">

                        <Col lg="6" sm="6" xs="12">
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/isaia-retail-store-digital-transformation.html`}>
                                <Row className="marssmt marssmb mglr0">

                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/isaia.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">ISAIA </h4>
                                        <p>Store Footfalls increased by 100% in 4 months </p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>

                        <Col lg="6" sm="6" xs="12" className="bgbl " >
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-conversion-rate-case-study.html`}>
                                <Row className="marssmt marssmb mglr0">
                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/saundh.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">Saundh </h4>
                                        <p>5X Improvement in E-Commerce Conversion Rate.</p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    )
}
export default BonnieAndSaks;

function Process() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    adaptiveHeight: true,
                }
            },],
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    adaptiveHeight: false,
                }
            },]
    };
    const next = () => {
        Slider.current.slickNext();
    }
    const previous = () => {
        Slider.current.slickPrev();
    }
    return (
        // <Container fluid className="reasons padslgt padslgb casestudy ">
        <Container fluid className="reasons padslgb casestudy ">
            <Row>
                <Col lg="10" className="offset-lg-1">
                    <Slider {...settings}>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >

                                    <h2 className="padt190"><span>OSIDE Targeting</span></h2>
                                    <h3 className=" padmsmb">Refined audience targeting for high-AOV collections (₹1L+) using income, location, job profiles, and luxury interests — connecting Bonnie & Saks with the right buyers.</h3>

                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/bonnie/process_ladder_1.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Architect & Interior Designer Growth (B2B)</span></h2>
                                    <h3 className=" padmsmb">Built a scalable B2B funnel for architects, interior designers, and home stylists, with tailored messaging, repeat-project focus, and an always-on lead generation system.</h3>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/bonnie/process_ladder_2.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Sales Enablement</span></h2>
                                    <h3 className=" padmsmb"> Implemented real-time WhatsApp lead delivery to ensure fast, high-touch follow-ups, reducing lead drop-offs.</h3>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/bonnie/process_ladder_3.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Event-Led Campaigns</span></h2>
                                    <h3 className=" padmsmb"> Activated RSVP and post-event campaigns for design showcases like India Design ID to convert awareness into high-quality interest.</h3>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/bonnie/process_ladder_4.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Luxury Positioning & Website Experience</span></h2>
                                    <h3 className=" padmsmb"> Sharpened the brand’s luxury narrative — craftsmanship, comfort, and contemporary design — and improved website storytelling, CTAs, and enquiry flows for a seamless, premium experience.</h3>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/bonnie/process_ladder_4.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                    </Slider>
                </Col>
            </Row>
        </Container>
    );
}